import { Modal } from 'antd'

import { ActionButton } from '@eastcoal/common/components/Button/ActionButton'
import { pick } from '@eastcoal/common/utils/object'

import { FormMode } from '@eastcoal/formily/components/CrudForm/enums/FormMode'
import { SubmitType } from '@eastcoal/formily/components/CrudForm/enums/SubmitType'
import { useCrudFormStore } from '@eastcoal/formily/components/CrudForm/Store/hooks/useStore'

import { AuctionFeeConfirmSaveButtonProps } from './interface'
import { useFeeConfirm } from './useFeeConfirm'

/**
 * 竞价场次保存按钮（带服务费/入场费二次确认）
 */
export const AuctionFeeConfirmSaveButton = ({
  icon,
  type = 'primary',
  children = '保存',
  ...restProps
}: AuctionFeeConfirmSaveButtonProps) => {
  const { mode, submitLoading } = useCrudFormStore(state =>
    pick(state, ['mode', 'submitLoading'])
  )

  const {
    isModalOpen,
    confirmContent,
    handleClick,
    handleConfirm,
    handleCancel
  } = useFeeConfirm()

  if (mode === FormMode.READ) {
    return null
  }

  return (
    <>
      <ActionButton
        ghost
        htmlType='submit'
        icon={icon}
        loading={submitLoading}
        type={type}
        onClick={() => handleClick({ submitType: SubmitType.SAVE })}
        {...restProps}
      >
        {children}
      </ActionButton>
      <Modal
        cancelText='否'
        okText='是'
        open={isModalOpen}
        title='提示'
        onCancel={handleCancel}
        onOk={handleConfirm}
      >
        {confirmContent}
      </Modal>
    </>
  )
}
